import { lazy } from 'react';
import { CAPABILITY_BILLING, CAPABILITY_HOSTED } from '../capabilities';
import { registerAdminSection, registerOrgSettingsTab, registerSite, registerStartHook } from './registry';
import { SITE_PUBLIC_PATHS } from '../site/paths';
import { sendVisitBeacon } from '../site/visitBeacon';

// openv.app's modules (OpenV's ext/registry.ts): this file replaces OpenV's
// src/ext/modules.ts when scripts/overlay-site.sh lays openv-hosted's
// frontend layer over the checkout. The billing tab and the visitors
// dashboard are still OpenV's components until its Phase 4 moves them here;
// the site and its visit beacon are this repository's.

registerOrgSettingsTab({
  key: 'billing',
  label: 'Billing',
  after: 'limits',
  capabilities: [CAPABILITY_HOSTED, CAPABILITY_BILLING],
  Component: lazy(() => import('../components/org/OrgBillingTab').then((m) => ({ default: m.OrgBillingTab }))),
});

registerAdminSection({
  key: 'visitors',
  capabilities: [CAPABILITY_HOSTED],
  Component: lazy(() =>
    import('../components/admin/VisitorDashboard').then((m) => ({ default: m.VisitorDashboard }))
  ),
});

registerStartHook({ key: 'visit-beacon', capabilities: [CAPABILITY_HOSTED], run: sendVisitBeacon });

// The marketing site: its front page and its pages, loaded only when a
// visitor opens one.
registerSite({
  capabilities: [CAPABILITY_HOSTED],
  publicPaths: SITE_PUBLIC_PATHS,
  Home: lazy(() => import('../site/routes').then((m) => ({ default: m.SiteHome }))),
  Pages: lazy(() => import('../site/routes').then((m) => ({ default: m.SitePages }))),
});
